import noop from "lib/noop"
import { ProcessVariable } from "event-definitions"
import { REMOVE_VARIABLE } from "lib/graphql/api"

export class StartAndFinish {
    constructor(startFn = noop, finishFn = noop) {
        this.startFn = startFn
        this.finishFn = finishFn
    }
}

export function withStartAndFinish(startFn, finishFn) {
    return new StartAndFinish(startFn, finishFn)
}

export function withStart(startFn) {
    return new StartAndFinish(startFn)
}

export function withFinish(finishFn) {
    return new StartAndFinish(noop, finishFn)
}

ProcessVariable.handleOnce(({ variable }) => {
    if (variable instanceof StartAndFinish) {
        return { startAndFinish: variable, variable: REMOVE_VARIABLE }
    }
    return undefined
})
